﻿import {writable} from "svelte/store";

export const sectionMeasurementsDateTimesStore = writable<Date[]>([]);